import React from "react";
import { Select } from "antd";

class SelectOptions extends React.Component {
    render() {
        const {
            options = [],
            placeholder = "",
            mode,
            className = "",
            onChange,
            value,
            disabled = false,
            allowClear = false,
            dropdownMatchSelectWidth = true,
            fieldName,
            size,
        } = this.props;
        return (
            <Select
                mode={mode}
                showSearch
                placeholder={placeholder}
                optionFilterProp="value"
                filterOption={(input, option) =>
                    option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                }
                className={className}
                onChange={onChange}
                value={value}
                disabled={disabled}
                allowClear={allowClear}
                dropdownMatchSelectWidth={dropdownMatchSelectWidth}
                data-at-id={fieldName}
                size={size}
            >
                {options.map((e, index) => (
                    <Select.Option key={index} value={e.value}>
                        {e.label}
                    </Select.Option>
                ))}
            </Select>
        );
    }
}

export default SelectOptions;
